export default function ({ instance, token }) {
  instance.defaults.headers.common.Authorization = `Bearer ${token}`;
}
